// @ts-nocheck
import React, {
    createContext,
    useContext,
} from "react";
import { useTranslation } from "react-i18next";


export const LanguageContext = createContext(undefined);

export const LanguageContextProvider = ({ children }) => {
    const languages = {
        en: { nativeName: "English" },
        It: { nativeName: "Italian" },
        sq: { nativeName: "Albanian" },
        de: { nativeName: "German" },
        es: { nativeName: "Spanish" },
        pl: { nativeName: "Polish" },
        ukr: { nativeName: "Ukrainian" },

    };
    const { t, i18n } = useTranslation();

    const onClickLanguageChange = (e) => {
        const language = e.target.value;
        i18n.changeLanguage(language); //change the language
    };

    return (
        <LanguageContext.Provider
            value={{ t, i18n, language: i18n.language, onClickLanguageChange, languages }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguageContext = () => useContext(LanguageContext);